<span *ngIf="data.label">{{data.label}}</span>